// extracted by mini-css-extract-plugin
export default {"details":"_246e2","actions":"_1-rTT","actionButton":"_2O1cK","mobile":"_3N3MQ","leftActions":"g4dAS","location":"_3IHzv","infoText":"H5tfv"};